import { useEffect } from "react";

const useInactivityLogoutTimer = (sessionExpired) => {

  const checkForInactivity = () => {
    const expireTimeString = localStorage.getItem('expireTime');
    const expireTime = expireTimeString ? parseInt(expireTimeString) : 0;

    if (expireTime < Date.now()) {
      localStorage.removeItem('token');
      sessionExpired();
    }
  };

  const updateExpiryTime = () => {
    const expireTime = Date.now() + (57 * 60 * 1000); //  in milliseconds
    localStorage.setItem('expireTime', expireTime.toString());
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkForInactivity();
    }, 5000); // Check for inactivity every 5 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    updateExpiryTime();
    window.addEventListener('click', updateExpiryTime);
    window.addEventListener('keypress', updateExpiryTime);
    window.addEventListener('scroll', updateExpiryTime);
    window.addEventListener('mousemove', updateExpiryTime);

    return () => {
      window.removeEventListener('click', updateExpiryTime);
      window.removeEventListener('keypress', updateExpiryTime);
      window.removeEventListener('scroll', updateExpiryTime);
      window.removeEventListener('mousemove', updateExpiryTime);
    };
  }, []);

  return null;
};

export default useInactivityLogoutTimer;